import { Component, Vue, Watch } from 'vue-property-decorator';
import LearnerIdentity from './learner-identity/learner-identity';
import LearnerList from './learner-list/learner-list';

@Component({
  components: {
    'learner-list': LearnerList,
    'learner-identity': LearnerIdentity,
  },
})
export default class Learners extends Vue {

}
